import { ShippingMethodsResponseDto } from '@tiendanube/common';
import { LocationResponseDto } from '@tiendanube/common/src/domains/shipping/locations/LocationResponseDto';
import { checkCustomPaymentProvider } from './utils';
import { PIPE_SEPARATOR, COMMA_SEPARATOR } from '../../ordersService/constants';

export interface SearchFilterInterfaceIdLabel {
  id: string;
  label: string;
}

interface PaymentProviderFilter {
  id: string;
  name?: string;
}

export function getShippingMethodChips(
  value: string,
  key: string,
  shippingMethods: ShippingMethodsResponseDto,
): SearchFilterInterfaceIdLabel[] {
  const methodCodes = value
    .split(COMMA_SEPARATOR)
    .map((v) => v.trim())
    .filter((v) => v !== '');
  const allMethods = Object.values(shippingMethods).flat();

  return methodCodes.map((methodCode) => {
    const method = allMethods.find(({ code }) => code === methodCode);
    return {
      id: `${key}-${methodCode}`,
      label: method?.name || methodCode,
    };
  });
}

export function getLocationChips(
  value: string,
  key: string,
  locations: LocationResponseDto[],
): SearchFilterInterfaceIdLabel[] {
  const locationIds = value
    .split(COMMA_SEPARATOR)
    .map((v) => v.trim())
    .filter((v) => v !== '');

  return locationIds.map((locationId) => {
    const location = locations.find(({ id }) => id === locationId);
    return {
      id: `${key}-${locationId}`,
      label: location?.name || locationId,
    };
  });
}

export function getStatusChips(
  value: string,
  key: string,
  translateFn: (key: string) => string,
): SearchFilterInterfaceIdLabel[] {
  const statusValues = value
    .split(COMMA_SEPARATOR)
    .map((v) => v.trim())
    .filter((v) => v !== '');

  return statusValues.map((statusValue) => ({
    id: `${key}-${statusValue}`,
    label: translateFn(`filters.status.${statusValue}`),
  }));
}

export function getPaymentMethodChips(
  value: string,
  key: string,
  translateFn: (key: string) => string,
): SearchFilterInterfaceIdLabel[] {
  const methodValues = value
    .split(COMMA_SEPARATOR)
    .map((v) => v.trim())
    .filter((v) => v !== '');

  return methodValues.map((methodValue) => ({
    id: `${key}-${methodValue}`,
    label: translateFn(`filters.paymentMethod.${methodValue}`),
  }));
}

export function getPaymentProviderChips(
  value: string,
  key: string,
  translateFn: (key: string) => string,
  paymentProvidersOrdersFilters: PaymentProviderFilter[],
): SearchFilterInterfaceIdLabel[] {
  const providerValues = value
    .split(PIPE_SEPARATOR)
    .map((v) => v.trim())
    .filter((v) => v !== '');

  return providerValues.map((providerValue) => {
    let label = providerValue;

    if (checkCustomPaymentProvider(key, providerValue)) {
      label = translateFn(`filters.paymentProvider.${providerValue}`);
    } else if (paymentProvidersOrdersFilters) {
      const provider = paymentProvidersOrdersFilters.find(
        ({ id }) => id === providerValue,
      );
      label = provider?.name || providerValue;
    }

    return {
      id: `${key}-${providerValue}`,
      label,
    };
  });
}
